var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video-background',{ref:"videoBackground",style:({ height: _vm.$_isDesktopView() ? '100vh' : '60vh' }),attrs:{"src":_vm.videoUrl,"poster":_vm.coverPhotoUrl,"autoplay":_vm.setAutoplay,"muted":false}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }